import includes from 'lodash/includes';
import pick from 'lodash/pick';
import values from 'lodash/values';
import {
  COGNITO_LOGOUT,
  SET_CHOSEN_PLAN,
  SET_ACTIVE_PLAN,
  SET_COUPON_CODE,
  SET_COUPON_ERROR,
  SET_PAYMENT_ERROR,
  SET_CHOSEN_SUMMARY,
  PLAN,
} from '../constants';

const DEFAULT_STATE = {
  chosenPlan: { name: PLAN.UNLIMITED, annual: true },
  activePlan: { name: undefined, annual: undefined, status: undefined },
  couponCode: undefined,
  couponError: undefined,
  paymentError: undefined,
  chosenSummary: undefined,
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case COGNITO_LOGOUT:
      return {
        ...state,
        activePlan: DEFAULT_STATE.activePlan,
        couponCode: DEFAULT_STATE.couponCode,
        couponError: DEFAULT_STATE.couponError,
        paymentError: DEFAULT_STATE.paymentError,
      };
    case SET_CHOSEN_PLAN:
      return {
        ...state,
        chosenPlan: { ...state.chosenPlan, ...action.payload },
      };
    case SET_ACTIVE_PLAN:
      return {
        ...state,
        activePlan: {
          name: action.payload.plan,
          annual: action.payload.annual,
          status: action.payload.status,
        },
        chosenPlan: {
          name: action.payload.plan || state.chosenPlan.name,
          annual:
            action.payload.annual === undefined
              ? state.chosenPlan.annual
              : action.payload.annual,
        },
      };
    case SET_COUPON_CODE:
      return {
        ...state,
        couponCode: action.payload,
      };
    case SET_COUPON_ERROR:
      return {
        ...state,
        couponError: action.payload,
        couponCode: undefined,
      };
    case SET_PAYMENT_ERROR:
      return {
        ...state,
        paymentError: action.payload,
      };
    case SET_CHOSEN_SUMMARY:
      return {
        ...state,
        chosenSummary: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan.js